import { fetchWithAuth, getCSRFToken } from '../auth';

const API = process.env.REACT_APP_ICC_TOOL_API_HOST;

export const getMarkets = () =>
    fetchWithAuth(`${API}markets/`, { method: 'GET', credentials: 'include' });

export const createMarket = (data) =>
    fetchWithAuth(`${API}markets/`, {
        method: 'POST',
        headers: { 'X-CSRFToken': getCSRFToken(), 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(data)
    });

export const updateMarket = (id, data) =>
    fetchWithAuth(`${API}markets/${id}/`, {
        method: 'PATCH',
        headers: { 'X-CSRFToken': getCSRFToken(), 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(data)
    });

export const deleteMarket = (id) =>
    fetchWithAuth(`${API}markets/${id}/`, {
        method: 'DELETE',
        headers: { 'X-CSRFToken': getCSRFToken() },
        credentials: 'include'
    });

export const assignMarketTeams = (id, teamIds) =>
    fetchWithAuth(`${API}markets/${id}/teams/`, {
        method: 'POST',
        headers: { 'X-CSRFToken': getCSRFToken(), 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ team_ids: teamIds })
    });

export const getAllTeams = () =>
    fetchWithAuth(`${API}teams/`, { method: 'GET', credentials: 'include' });
